module.exports = __webpack_public_path__ + "img/vote-6@2x.a60e8015.png";